<div class="container" *ngIf="message">
  <mat-card>
    <mat-card-header>
      <mat-card-title
        ><h2 class="primaryColor">Down for Maintenance</h2></mat-card-title
      >
    </mat-card-header>
    <mat-card-content>
      <p>
        <strong>
          {{ message }}
        </strong>
      </p>
    </mat-card-content>
  </mat-card>
</div>
